import React, { useState, useEffect, useRef } from "react";
import axios from "axios";

const API = "https://ggaarts.onrender.com/api";

const Admin = () => {
  const [auth, setAuth] = useState(false);
  const [password, setPassword] = useState("");

  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("other");
  const [image, setImage] = useState(null);
  const [artworks, setArtworks] = useState([]);
  const fileRef = useRef();

  // -----------------------------------
  // SIMPLE FRONTEND PASSWORD CHECK
  // -----------------------------------
  const checkPassword = () => {
    if (password === "ggaarts123") setAuth(true);
    else alert("Incorrect Password ❌");
  };

  // -----------------------------------
  // LOAD ARTWORKS
  // -----------------------------------
  const loadArtworks = async () => {
    try {
      const res = await axios.get(`${API}/artworks`);
      setArtworks(res.data);
    } catch (err) {
      console.error("Load error:", err);
      alert("Cannot reach server");
    }
  };

  useEffect(() => {
    if (auth) loadArtworks();
  }, [auth]);

  // -----------------------------------
  // UPLOAD ARTWORK
  // -----------------------------------
  const uploadArtwork = async () => {
    if (!name || !description || !category || !image) {
      alert("All fields + image required");
      return;
    }

    const fd = new FormData();
    fd.append("name", name);
    fd.append("price", price);
    fd.append("description", description);
    fd.append("category", category);
    fd.append("image", image);

    try {
      await axios.post(`${API}/artworks`, fd);
      alert("Uploaded ✔");
      setName("");
      setPrice("");
      setDescription("");
      setCategory("other");
      setImage(null);
      fileRef.current.value = "";
      loadArtworks();
    } catch (err) {
      console.error("Upload error:", err);
      alert("Upload failed");
    }
  };

  // -----------------------------------
  // DELETE
  // -----------------------------------
  const deleteArtwork = async (id) => {
    if (!window.confirm("Delete this artwork?")) return;

    try {
      await axios.delete(`${API}/artworks/${id}`);
      loadArtworks();
    } catch (err) {
      console.error("Delete error:", err);
      alert("Delete failed");
    }
  };

  // -----------------------------------
  // PASSWORD SCREEN (IF NOT AUTH)
  // -----------------------------------
 if (!auth) {
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        background: "#0a0a0a",
        color: "white",
        padding: "20px",
      }}
    >
      <h2 style={{ marginBottom: 15, fontSize: "1.4rem" }}>
        Admin Access Only
      </h2>

      <input
        type="password"
        className="admin-login-input"
        placeholder="Enter Admin Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />

      <button className="admin-login-btn" onClick={checkPassword}>
        Enter
      </button>
    </div>
  );
}

  // -----------------------------------
  // ADMIN PANEL
  // -----------------------------------
  return (
    <div style={{ padding: 20, maxWidth: 900, margin: "0 auto" }}>
      <h1>Admin Panel</h1>

      <input
        placeholder="Artwork Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        style={inputStyle}
      />

      <input
        type="number"
        placeholder="Price"
        value={price}
        onChange={(e) => setPrice(e.target.value)}
        style={inputStyle}
      />

      <textarea
        placeholder="Description"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        style={inputStyle}
      />

      <select
        value={category}
        onChange={(e) => setCategory(e.target.value)}
        style={inputStyle}
      >
        <option value="other">Other</option>
        <option value="history">History</option>
        <option value="karnataka">Karnataka</option>
        <option value="content_creators">Content Creators</option>
      </select>

      <input
        type="file"
        ref={fileRef}
        accept="image/*"
        onChange={(e) => setImage(e.target.files[0])}
        style={inputStyle}
      />

      <button onClick={uploadArtwork} style={btnStyle}>
        Upload Artwork
      </button>

      <h2 style={{ marginTop: 40 }}>All Artworks</h2>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
          gap: 20,
        }}
      >
        {artworks.map((art) => (
          <div
            key={art._id}
            style={{
              background: "#fff",
              padding: 15,
              borderRadius: 12,
              boxShadow: "0 4px 10px rgba(0,0,0,0.1)"
            }}
          >
            <img
              src={art.image}
              alt={art.name}
              style={{
                width: "100%",
                height: 160,
                objectFit: "cover",
                borderRadius: 8,
              }}
              onError={(e) =>
                (e.target.src =
                  "https://via.placeholder.com/300x160?text=No+Image")
              }
            />

            <h3>{art.name}</h3>
            {art.category === "content_creators" ? (
              <p style={{ color: "red", fontWeight: "bold" }}>Not For Sale</p>
            ) : (
              <p>₹{art.price}</p>
            )}

            <button
              onClick={() => deleteArtwork(art._id)}
              style={deleteBtnStyle}
            >
              Delete
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

const inputStyle = {
  padding: "12px",
  margin: "10px 0",
  width: "100%",
  borderRadius: "8px",
  background: "rgba(255,255,255,0.1)",
  border: "1px solid #d4af37",
  color: "black"
};

const btnStyle = {
  padding: "14px",
  background: "#d4af37",
  color: "#000",
  border: "none",
  width: "100%",
  borderRadius: 8,
  fontWeight: "bold",
  cursor: "pointer"
};

const deleteBtnStyle = {
  marginTop: 10,
  background: "#dc3545",
  color: "white",
  width: "100%",
  padding: 10,
  borderRadius: 8,
  border: "none",
  cursor: "pointer",
};

export default Admin;
